// Dynamically determine the redirect URI based on the current window location
const getRedirectUri = () => {
  if (typeof window !== 'undefined') {
    // Get the origin (protocol + hostname + port)
    return window.location.origin;
  }
  // Fallback for SSR or when window is not available
  return 'http://localhost:3000';
};

// Backend API scope — the single source of truth for token acquisition
export const API_SCOPE = "https://coordnorway.onmicrosoft.com/00b3dff4-2441-42a4-8d01-65a27362baa2/User.Read";

// Scopes for login popup — includes API scope so first login returns an accessToken
export const loginRequest = {
  scopes: ["openid", "offline_access", API_SCOPE],
};

// Scopes for silent token acquisition
export const tokenRequest = {
  scopes: [API_SCOPE],
};

const msalConfig = {
    auth: {
      clientId: "3e97e043-101e-4bcd-9323-845b442dd598",
      authority: "https://coordnorway.b2clogin.com/coordnorway.onmicrosoft.com/B2C_1_SignInSignUp",
      knownAuthorities: ["coordnorway.b2clogin.com"],
      redirectUri: getRedirectUri(),
      postLogoutRedirectUri: getRedirectUri(),
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
};

  export default msalConfig;